export const SET_DOCTORPAGE_SET='SET_DOCTORPAGE_SET' //设置医生主页信息
export const SET_DOCTORPAGE_SET_STATE='SET_DOCTORPAGE_SET_STATE'//设置医生主页信息状态
export const SET_ORDERCONFIRM_SET='SET_ORDERCONFIRM_SET' //设置医生主页信息
export const SET_ORDERCONFIRM_SET_STATE='SET_ORDERCONFIRM_SET_STATE'//设置医生主页信息状态
export const SET_BEAUTYITEM_SET='SET_BEAUTYITEM_SET' //设置皮肤列表护肤建议商品信息
export const SET_BEAUTYITEM_SET_STATE='SET_BEAUTYITEM_SET_STATE'//设置皮肤列表护肤建议商品信息状态
export const SET_CONFIRMRESULT_SET='SET_CONFIRMRESULT_SET' //设置皮肤列表护肤建议商品信息
export const SET_CONFIRMRESULT_SET_STATE='SET_CONFIRMRESULT_SET_STATE'//设置皮肤列表护肤建议商品信息状态
export const SET_RONGYUN_SET='SET_RONGYUN_SET' //设置聊天信息
export const SET_RONGYUN_SET_STATE='SET_RONGYUN_SET_STATE'//设置设置聊天信息信息状态



// WEBPACK FOOTER //
// ./src/vuex/types.js